import { defineStore } from 'pinia';
import {getPaymentMethods, login} from '../api.js';

export const usePaymentMethodsStore = defineStore('payment-methods', {
    state: () => ({
        methods: [],
        loading: false,
        error: null
    }),
    actions: {
        async fetchPaymentMethods() {
            console.log('fetchPaymentMethods');
            this.loading = true;
            this.error = null;
            try {
                const data = await getPaymentMethods();
                this.methods = data.data;
            } catch (err) {
                this.error = err;
            } finally {
                this.loading = false;
            }
        }
    },
    getters:{
        getDefaultMethod(state){
            return state.methods.find(method => method.is_default);
        }
    },
    persist: true
});
